var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, Row, Col, PaneFooter, AccordionSet, Accordion, Checkbox, ErrorModal, Loading, ConfirmationModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import styles from "./UserEdit.module.css";
import { fetchOrganizationOptions } from "../../api/organizationService";
import { usePickerOptions } from "../../hooks/usePickerOptions";
import { PickerHint } from "../../components/PickerHint";
import { createUserEditSchema } from "../../utils/validationUtils";
import { assignUserToOrganization, fetchCurrentUser, fetchUserById, fetchUserOrganizations, manageUserOrganization, removeUserFromOrganization, updateUser, } from "../../api/usersService";
import { RecekTextField, RecekSelection } from "../../components/inputs";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { handleUserEditErrors } from "../../utils/handleUserEditErrors";
import { NK_ORG_UUID } from "../../utils/constants";
import { hasRole, useActiveRoles } from "../../utils/permissionsUtils";
import { RoleEnum } from "../../types/RoleEnum";
import { useUserData } from "../../hooks/useUserData";
import { formatOrganizationName } from "../../utils/organizationUtils";
import { useScrollToError } from "../../hooks/useScrollToError";
import { ExportApiClientRoleCheckbox } from "../../components/ExportApiClientRoleCheckbox";
import { isRoleLockedByExportApiClient, orderMembershipsForSave, planMembershipRemovals, } from "../../utils/exportApiClientExclusivity";
var UserEdit = function () {
    var _a;
    var _b, _c, _d, _e, _f;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _g = useState(""), selectedOrganization = _g[0], setSelectedOrganization = _g[1];
    var _h = useState([]), removedOrganizations = _h[0], setRemovedOrganizations = _h[1];
    var _j = useState(false), confirmModalOpen = _j[0], setConfirmModalOpen = _j[1];
    var _k = useState(false), errorModalOpen = _k[0], setErrorModalOpen = _k[1];
    var _l = useState(""), errorMessage = _l[0], setErrorMessage = _l[1];
    var _m = useState(false), isEmailUnlocked = _m[0], setIsEmailUnlocked = _m[1];
    var _o = useState(null), emailChangeContext = _o[0], setEmailChangeContext = _o[1];
    var _p = useState([]), userOrganizations = _p[0], setUserOrganizations = _p[1];
    var _q = useUserData(id), countsLoading = _q.countsLoading, canEditEmail = _q.canEditEmail, isCountsError = _q.isCountsError, organizationsCountError = _q.organizationsCountError, sourcesCountError = _q.sourcesCountError;
    var _r = useForm({
        resolver: zodResolver(createUserEditSchema(intl)),
        defaultValues: {
            email: "",
            firstName: "",
            lastName: "",
            shouldChangePassword: true,
            version: 0,
        },
        mode: "onBlur",
    }), handleSubmit = _r.handleSubmit, reset = _r.reset, resetField = _r.resetField, setValue = _r.setValue, control = _r.control, errors = _r.formState.errors;
    var _s = useState(true), expandAll = _s[0], setExpandAll = _s[1];
    var _t = useState({
        userOrganizations: true,
        organization: true,
        profile: true,
        role: true,
    }), accordionStatus = _t[0], setAccordionStatus = _t[1];
    useScrollToError(errors);
    var _u = useQuery(["user", id], function () { return fetchUserById(ky, id); }, {
        enabled: !!id,
    }), userData = _u.data, isUserLoading = _u.isLoading;
    var _v = useQuery(["organizations", id], function () { return fetchUserOrganizations(ky, id); }, {
        enabled: !!id,
    }), userOrganizationsData = _v.data, isOrgLoading = _v.isLoading;
    // The form is the editor's target state: loaded once, never overwritten by a refetch - after a failed save the
    // server state is refetched for the retry and the edits stay (DB-946). Only the version of the editor's OWN
    // successful profile update is taken over (see saveUser); someone else's change still ends in a 409.
    var formLoaded = useRef(false);
    useEffect(function () {
        var _a;
        if (!formLoaded.current &&
            !isUserLoading &&
            !isOrgLoading &&
            userData &&
            userOrganizationsData) {
            formLoaded.current = true;
            reset({
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                shouldChangePassword: (_a = userData.shouldChangePassword) !== null && _a !== void 0 ? _a : true,
                version: userData.version,
            });
            setUserOrganizations(userOrganizationsData);
            setIsEmailUnlocked(false);
        }
    }, [isUserLoading, isOrgLoading, userData, userOrganizationsData, reset]);
    var _w = useQuery(["currentUser"], function () { return fetchCurrentUser(ky); }, { staleTime: Infinity }), currentUser = _w.data, isCurrentUserLoading = _w.isLoading;
    var activeRoles = useActiveRoles().roles;
    var isSuperUser = hasRole(activeRoles, RoleEnum.SUPERUSER);
    var isAgencyWorker = hasRole(activeRoles, RoleEnum.AGENCY_WORKER);
    var isAdminLegalDeposits = hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS);
    var isPublisherAdmin = hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN);
    var isOnlyPublisherAdmin = isPublisherAdmin &&
        !isSuperUser &&
        !isAgencyWorker &&
        !isAdminLegalDeposits;
    var publisherAdminOrgId = (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.id;
    var canUnlockEmail = isSuperUser || isAgencyWorker;
    var isEmailEditable = canEditEmail || (canUnlockEmail && isEmailUnlocked);
    var isOrgDisabledForPublisherAdmin = function (orgId) {
        return isOnlyPublisherAdmin && orgId !== publisherAdminOrgId;
    };
    var canEditAgencyWorkerRole = function (orgId) {
        var _a;
        return !isCurrentUserLoading &&
            (isSuperUser ||
                (isAgencyWorker &&
                    ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.id) === NK_ORG_UUID &&
                    orgId === NK_ORG_UUID));
    };
    var canEditNKSpecialRoles = function (orgId) {
        return (isSuperUser || isAgencyWorker) && orgId === NK_ORG_UUID;
    };
    var canEditDistributorRole = function () { return isSuperUser || isAgencyWorker; };
    var canEditPublisherRoles = function (orgId) {
        if (isOrgDisabledForPublisherAdmin(orgId))
            return false;
        return isSuperUser || !isAdminLegalDeposits;
    };
    var canEditLegalDepositsRoles = function () { return isSuperUser || isAdminLegalDeposits; };
    // DB-946: ExportApiClient excludes every other role of the user, in any membership
    var isRoleLocked = function (orgIndex, role) {
        return isRoleLockedByExportApiClient(userOrganizations.map(function (org) { var _a; return (_a = org.roles) !== null && _a !== void 0 ? _a : []; }), orgIndex, role);
    };
    var _x = useState({ name: "" }), filters = _x[0], setFilters = _x[1];
    // DB-876: debounced, abortable search-as-you-type; a full page asks to refine the search
    var _y = usePickerOptions(filters.name, function (name, signal) {
        return fetchOrganizationOptions(ky, name, signal).then(function (page) { var _a; return (_a = page.organizations) !== null && _a !== void 0 ? _a : []; });
    }), organizationOptions = _y.options, isFetching = _y.loading, organizationsTruncated = _y.truncated;
    var saveUser = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var deleted, deleteMembership, profileUpdated, orgsToSave, removals, _i, _a, orgUuid, _b, _c, org, _d, orgsToSave_1, org, _e, _f, orgUuid, error_1, stored, refetchError_1;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    deleted = [];
                    deleteMembership = function (orgUuid) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, removeUserFromOrganization(ky, id, orgUuid)];
                                case 1:
                                    _a.sent();
                                    deleted.push(orgUuid);
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    profileUpdated = false;
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 19, , 24]);
                    return [4 /*yield*/, updateUser(ky, id, data)];
                case 2:
                    _g.sent();
                    profileUpdated = true;
                    orgsToSave = isOnlyPublisherAdmin
                        ? userOrganizations.filter(function (org) { return org.organization.id === publisherAdminOrgId; })
                        : userOrganizations;
                    removals = isOnlyPublisherAdmin
                        ? { beforeRoleChanges: [], afterRoleChanges: [] }
                        : planMembershipRemovals(removedOrganizations, userOrganizationsData !== null && userOrganizationsData !== void 0 ? userOrganizationsData : [], userOrganizations);
                    _i = 0, _a = removals.beforeRoleChanges;
                    _g.label = 3;
                case 3:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    orgUuid = _a[_i];
                    return [4 /*yield*/, deleteMembership(orgUuid)];
                case 4:
                    _g.sent();
                    _g.label = 5;
                case 5:
                    _i++;
                    return [3 /*break*/, 3];
                case 6:
                    _b = 0, _c = orderMembershipsForSave(orgsToSave, userOrganizationsData !== null && userOrganizationsData !== void 0 ? userOrganizationsData : []);
                    _g.label = 7;
                case 7:
                    if (!(_b < _c.length)) return [3 /*break*/, 10];
                    org = _c[_b];
                    return [4 /*yield*/, assignUserToOrganization(ky, id, org.organization.id, org.roles)];
                case 8:
                    _g.sent();
                    _g.label = 9;
                case 9:
                    _b++;
                    return [3 /*break*/, 7];
                case 10:
                    _d = 0, orgsToSave_1 = orgsToSave;
                    _g.label = 11;
                case 11:
                    if (!(_d < orgsToSave_1.length)) return [3 /*break*/, 14];
                    org = orgsToSave_1[_d];
                    return [4 /*yield*/, manageUserOrganization(ky, id, org.organization.id, org.archived ? "archive" : "restore")];
                case 12:
                    _g.sent();
                    _g.label = 13;
                case 13:
                    _d++;
                    return [3 /*break*/, 11];
                case 14:
                    _e = 0, _f = removals.afterRoleChanges;
                    _g.label = 15;
                case 15:
                    if (!(_e < _f.length)) return [3 /*break*/, 18];
                    orgUuid = _f[_e];
                    return [4 /*yield*/, deleteMembership(orgUuid)];
                case 16:
                    _g.sent();
                    _g.label = 17;
                case 17:
                    _e++;
                    return [3 /*break*/, 15];
                case 18:
                    history.goBack();
                    return [3 /*break*/, 24];
                case 19:
                    error_1 = _g.sent();
                    // a retry must neither delete a membership again (404) nor work from a stale server state
                    if (deleted.length > 0) {
                        setRemovedOrganizations(function (prev) { return prev.filter(function (orgUuid) { return !deleted.includes(orgUuid); }); });
                    }
                    queryClient.invalidateQueries(["organizations", id]);
                    if (!profileUpdated) return [3 /*break*/, 23];
                    _g.label = 20;
                case 20:
                    _g.trys.push([20, 22, , 23]);
                    return [4 /*yield*/, queryClient.fetchQuery(["user", id], function () {
                            return fetchUserById(ky, id);
                        })];
                case 21:
                    stored = _g.sent();
                    setValue("version", stored.version);
                    return [3 /*break*/, 23];
                case 22:
                    refetchError_1 = _g.sent();
                    // eslint-disable-next-line no-console
                    console.error("Error reloading the user after a failed save:", refetchError_1);
                    return [3 /*break*/, 23];
                case 23:
                    handleUserEditErrors({
                        error: error_1,
                        setErrorMessage: setErrorMessage,
                        setConfirmModalOpen: setConfirmModalOpen,
                        setErrorModalOpen: setErrorModalOpen,
                        formatMessage: formatMessage,
                    });
                    return [3 /*break*/, 24];
                case 24: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (data.email !== (userData === null || userData === void 0 ? void 0 : userData.email)) {
                        setEmailChangeContext({ data: data, oldEmail: (_a = userData === null || userData === void 0 ? void 0 : userData.email) !== null && _a !== void 0 ? _a : "" });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, saveUser(data)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getArchiveButtonLabel = function (isArchived) {
        return isArchived
            ? formatMessage({ id: "ui-br-users.organization.label.restore" })
            : formatMessage({ id: "ui-br-users.organization.label.archive" });
    };
    var handleArchivesButtonChanged = function (index, archiveOrganization) {
        var updatedOrgs = __spreadArray([], userOrganizations, true);
        updatedOrgs[index] = __assign(__assign({}, updatedOrgs[index]), { archived: archiveOrganization });
        setUserOrganizations(updatedOrgs);
    };
    // RECEK-74528: the publisher admin and guarantor roles are mutually exclusive per user
    // within an organization. Selecting one automatically unselects the other.
    var mutuallyExclusiveRole = (_a = {},
        _a[RoleEnum.PUBLISHER_ADMIN] = RoleEnum.PUBLISHER_GUARANTOR,
        _a[RoleEnum.PUBLISHER_GUARANTOR] = RoleEnum.PUBLISHER_ADMIN,
        _a);
    var handleRoleChange = function (_a) {
        var orgIndex = _a.orgIndex, role = _a.role, isChecked = _a.isChecked;
        setUserOrganizations(function (prevOrgs) {
            return prevOrgs.map(function (org, index) {
                if (index !== orgIndex)
                    return org;
                var currentRoles = org.roles || [];
                if (isChecked && !currentRoles.includes(role)) {
                    var excluded_1 = mutuallyExclusiveRole[role];
                    var withoutExcluded = excluded_1
                        ? currentRoles.filter(function (r) { return r !== excluded_1; })
                        : currentRoles;
                    return __assign(__assign({}, org), { roles: __spreadArray(__spreadArray([], withoutExcluded, true), [role], false) });
                }
                if (!isChecked) {
                    return __assign(__assign({}, org), { roles: currentRoles.filter(function (r) { return r !== role; }) });
                }
                return org;
            });
        });
    };
    var expandAllSections = function () {
        setAccordionStatus({
            userOrganizations: true,
            organization: true,
            profile: true,
            role: true,
        });
        setExpandAll(true);
    };
    var collapseAllSections = function () {
        setAccordionStatus({
            userOrganizations: false,
            organization: false,
            profile: false,
            role: false,
        });
        setExpandAll(false);
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            collapseAllSections();
        }
        else {
            expandAllSections();
        }
    };
    if (isUserLoading || isOrgLoading || countsLoading) {
        return React.createElement(Loading, null);
    }
    if (isCountsError) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("p", null, (organizationsCountError === null || organizationsCountError === void 0 ? void 0 : organizationsCountError.message) || (React.createElement(FormattedMessage, { id: "ui-br-users.error.organizationsCount.not.found" }))),
                React.createElement("p", null, (sourcesCountError === null || sourcesCountError === void 0 ? void 0 : sourcesCountError.message) || (React.createElement(FormattedMessage, { id: "ui-br-users.error.sourcesCount.not.found" }))))));
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-users.users.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, onClick: handleSubmit(onSubmit) },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); }, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.cancel" })) }) },
            React.createElement(ConfirmationModal, { open: confirmModalOpen, heading: "Chyba", message: errorMessage, onConfirm: function () { return window.location.reload(); }, onCancel: function () { return setConfirmModalOpen(false); }, confirmLabel: formatMessage({
                    id: "ui-br-users.button.refresh",
                }), cancelLabel: formatMessage({
                    id: "ui-br-users.button.close",
                }), buttonStyle: "primary" }),
            React.createElement(ConfirmationModal, { open: emailChangeContext !== null, heading: formatMessage({
                    id: "ui-br-users.users.email.changeConfirm.title",
                }), message: React.createElement(FormattedMessage, { id: "ui-br-users.users.email.changeConfirm.message", values: {
                        name: "".concat((_c = userData === null || userData === void 0 ? void 0 : userData.firstName) !== null && _c !== void 0 ? _c : "", " ").concat((_d = userData === null || userData === void 0 ? void 0 : userData.lastName) !== null && _d !== void 0 ? _d : "").trim(),
                        oldEmail: React.createElement("strong", null, (_e = emailChangeContext === null || emailChangeContext === void 0 ? void 0 : emailChangeContext.oldEmail) !== null && _e !== void 0 ? _e : ""),
                        newEmail: (React.createElement("strong", null, (_f = emailChangeContext === null || emailChangeContext === void 0 ? void 0 : emailChangeContext.data.email) !== null && _f !== void 0 ? _f : "")),
                    } }), confirmLabel: formatMessage({
                    id: "ui-br-users.users.email.changeConfirm.confirm",
                }), cancelLabel: formatMessage({ id: "ui-br-users.button.cancel" }), onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!emailChangeContext) return [3 /*break*/, 2];
                                data = emailChangeContext.data;
                                setEmailChangeContext(null);
                                return [4 /*yield*/, saveUser(data)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); }, onCancel: function () {
                    resetField("email");
                    setIsEmailUnlocked(false);
                    setEmailChangeContext(null);
                } }),
            React.createElement(ErrorModal, { open: errorModalOpen, label: "Chyba", content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } }, "Zav\u0159\u00EDt")),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll ? (React.createElement(FormattedMessage, { id: "ui-br-users.button.collapse" })) : (React.createElement(FormattedMessage, { id: "ui-br-users.button.expand" }))))),
            React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.profile",
                        }), open: accordionStatus.profile, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { profile: !accordionStatus.profile }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "firstName", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.firstName", required: true }, field, { error: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "lastName", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.lastName", required: true }, field, { error: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement("div", { className: styles.emailRow },
                                    React.createElement("div", { className: styles.emailField },
                                        React.createElement(Controller, { control: control, name: "email", render: function (_a) {
                                                var _b;
                                                var field = _a.field;
                                                return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.email", required: isEmailEditable }, field, { error: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message })));
                                            }, disabled: !isEmailEditable })),
                                    !canEditEmail && canUnlockEmail && (React.createElement("div", { className: styles.emailActionButton },
                                        React.createElement(Button, { buttonStyle: isEmailUnlocked ? "danger" : "primary", marginBottom0: true, onClick: function () {
                                                if (isEmailUnlocked) {
                                                    resetField("email");
                                                }
                                                setIsEmailUnlocked(!isEmailUnlocked);
                                            } },
                                            React.createElement(FormattedMessage, { id: isEmailUnlocked
                                                    ? "ui-br-users.users.email.reset.label"
                                                    : "ui-br-users.users.email.edit.label" })))))))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.userOrganizations",
                        }), open: accordionStatus.userOrganizations, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { userOrganizations: !accordionStatus.userOrganizations }));
                        } }, userOrganizations.map(function (org, index) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                        return (React.createElement(Row, { key: org.organization.id, className: styles.organizationRow },
                            React.createElement(Col, { xs: 3 },
                                React.createElement("strong", { style: {
                                        textDecoration: org.archived ? "line-through" : "none",
                                    } }, formatOrganizationName(org.organization))),
                            React.createElement(Col, { xs: 3 },
                                isOrgDisabledForPublisherAdmin(org.organization.id) &&
                                    ((_a = org.roles) === null || _a === void 0 ? void 0 : _a.map(function (role) { return (React.createElement("div", { key: role },
                                        React.createElement("strong", null, formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.".concat(role[0].toLowerCase()).concat(role.slice(1)),
                                        })))); })),
                                canEditPublisherRoles(org.organization.id) && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.publisherAdmin",
                                        }), name: "publisherAdmin", checked: (_b = org.roles) === null || _b === void 0 ? void 0 : _b.includes("PublisherAdmin"), disabled: isRoleLocked(index, "PublisherAdmin"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "PublisherAdmin",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.publisherGuarantor",
                                        }), name: "publisherGuarantor", checked: (_c = org.roles) === null || _c === void 0 ? void 0 : _c.includes("PublisherGuarantor"), disabled: isRoleLocked(index, "PublisherGuarantor"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "PublisherGuarantor",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement("p", { className: styles.roleHint },
                                        React.createElement(FormattedMessage, { id: "ui-br-users.users.organization.roles.publisherExclusivityHint" })))),
                                canEditAgencyWorkerRole(org.organization.id) && (React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-users.users.organization.roles.checkbox.label.agencyWorker",
                                    }), checked: (_d = org.roles) === null || _d === void 0 ? void 0 : _d.includes("AgencyWorker"), disabled: isRoleLocked(index, "AgencyWorker"), onChange: function (e) {
                                        return handleRoleChange({
                                            orgIndex: index,
                                            role: "AgencyWorker",
                                            isChecked: e.target.checked,
                                        });
                                    } })),
                                canEditNKSpecialRoles(org.organization.id) && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.collectionsAdministrator",
                                        }), checked: (_e = org.roles) === null || _e === void 0 ? void 0 : _e.includes("CollectionsAdministrator"), disabled: isRoleLocked(index, "CollectionsAdministrator"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "CollectionsAdministrator",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.onixCodetablesAdministrator",
                                        }), checked: (_f = org.roles) === null || _f === void 0 ? void 0 : _f.includes("OnixCodetablesAdministrator"), disabled: isRoleLocked(index, "OnixCodetablesAdministrator"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "OnixCodetablesAdministrator",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement(ExportApiClientRoleCheckbox, { checked: !!((_g = org.roles) === null || _g === void 0 ? void 0 : _g.includes(RoleEnum.EXPORT_API_CLIENT)), disabled: isRoleLocked(index, RoleEnum.EXPORT_API_CLIENT), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: RoleEnum.EXPORT_API_CLIENT,
                                                isChecked: e.target.checked,
                                            });
                                        } }))),
                                canEditDistributorRole() && (React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-users.users.organization.roles.checkbox.label.distributor",
                                    }), checked: (_h = org.roles) === null || _h === void 0 ? void 0 : _h.includes("Distributor"), disabled: isRoleLocked(index, "Distributor"), onChange: function (e) {
                                        return handleRoleChange({
                                            orgIndex: index,
                                            role: "Distributor",
                                            isChecked: e.target.checked,
                                        });
                                    } })),
                                canEditLegalDepositsRoles() && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.adminLegalDeposits",
                                        }), checked: (_j = org.roles) === null || _j === void 0 ? void 0 : _j.includes("AdminLegalDeposits"), disabled: isRoleLocked(index, "AdminLegalDeposits"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "AdminLegalDeposits",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.librarianLegalDepositsMonographs",
                                        }), checked: (_k = org.roles) === null || _k === void 0 ? void 0 : _k.includes("LibrarianLegalDepositsMonographs"), disabled: isRoleLocked(index, "LibrarianLegalDepositsMonographs"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "LibrarianLegalDepositsMonographs",
                                                isChecked: e.target.checked,
                                            });
                                        } }),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.librarianLegalDepositsPeriodicals",
                                        }), checked: (_l = org.roles) === null || _l === void 0 ? void 0 : _l.includes("LibrarianLegalDepositsPeriodicals"), disabled: isRoleLocked(index, "LibrarianLegalDepositsPeriodicals"), onChange: function (e) {
                                            return handleRoleChange({
                                                orgIndex: index,
                                                role: "LibrarianLegalDepositsPeriodicals",
                                                isChecked: e.target.checked,
                                            });
                                        } })))),
                            React.createElement(Col, { xs: 3 },
                                React.createElement(Button, { buttonStyle: "warning", disabled: isOrgDisabledForPublisherAdmin(org.organization.id), onClick: function () {
                                        handleArchivesButtonChanged(index, !org.archived);
                                    } }, getArchiveButtonLabel(org.archived))),
                            React.createElement(Col, { xs: 3 },
                                React.createElement(Button, { buttonStyle: "danger", disabled: isOrgDisabledForPublisherAdmin(org.organization.id), onClick: function () {
                                        var removedOrgId = userOrganizations[index].organization.id;
                                        if (removedOrgId) {
                                            setRemovedOrganizations(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                                removedOrgId,
                                            ], false); });
                                        }
                                        setUserOrganizations(userOrganizations.filter(function (_, i) { return i !== index; }));
                                    } },
                                    React.createElement(FormattedMessage, { id: "ui-br-users.users.button.removeOrganization" })))));
                    })),
                    !isOnlyPublisherAdmin && (React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.organization",
                        }), open: accordionStatus.organization, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { organization: !accordionStatus.organization }));
                        } },
                        React.createElement(Col, { xs: 6 },
                            React.createElement(RecekSelection, { labelId: "ui-br-users.label.organization", asyncFilter: true, loading: isFetching, name: "organization", onChange: function (value) { return setSelectedOrganization(value); }, onFilter: function (value) {
                                    setFilters({ name: value });
                                }, value: selectedOrganization, dataOptions: organizationOptions.map(function (org) { return ({
                                    value: org.id,
                                    label: formatOrganizationName(org),
                                }); }) }),
                            React.createElement(PickerHint, { truncated: organizationsTruncated })),
                        React.createElement(Button, { onClick: function () {
                                var selectedOrg = organizationOptions.find(function (org) { return org.id === selectedOrganization; });
                                if (selectedOrg) {
                                    var exists = userOrganizations.some(function (org) { return org.organization.id === selectedOrg.id; });
                                    if (!exists) {
                                        setUserOrganizations(__spreadArray(__spreadArray([], userOrganizations, true), [
                                            {
                                                user: userData,
                                                organization: selectedOrg,
                                                roles: [],
                                                archived: false,
                                            },
                                        ], false));
                                    }
                                }
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-users.users.button.addOrganization" })))))))));
};
export default UserEdit;
